import {
  BodyText,
  Card,
  CardContent,
  DetailText,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';
import { TickMediumIcon } from '@utilitywarehouse/hearth-react-icons';
import MascotInsuranceLight from '@utilitywarehouse/hearth-svg-assets/lib/mascot-insurance-light.svg';
import { FC } from 'react';

import './styles.scss';

interface HeroProps {
  price: string;
}

interface BreakdownItemProps {
  text: string;
}

const BreakdownItem: FC<BreakdownItemProps> = ({ text }) => (
  <Flex asChild spacing="sm">
    <li>
      <TickMediumIcon />
      <BodyText size="lg">{text}</BodyText>
    </li>
  </Flex>
);

const IncomeProtectorHero = ({ price }: HeroProps) => (
  <Flex className="ip-hero__wrapper" spacing="xl" direction="column">
    <Heading as="h1" size="xl" data-testid="ip-hero-title">
      Income Protector
    </Heading>
    <DetailText size="3xl" data-testid="ip-hero-price">
      {price} <BodyText as="span">a month</BodyText>
    </DetailText>
    <Card variant="subtle" colorScheme="insurance">
      <CardContent spacing="lg">
        <Flex flex="1 0 80px" display={{ mobile: 'none', tablet: 'flex' }}>
          <img src={MascotInsuranceLight} alt="" />
        </Flex>
        <Flex direction="column" spacing="sm">
          <Heading size="sm">Protection if you’re unable to work</Heading>
          <BodyText>
            If you lose your job, become unemployed or are unable to work due to
            illness or an accident, UW's Income Protector replaces some of your
            lost income.
          </BodyText>
        </Flex>
      </CardContent>
    </Card>
    <Flex asChild spacing="lg" direction="column">
      <ul className="ip-hero__list">
        <BreakdownItem text="Up to £750 per month for up to six months if you are unable to work" />
        <BreakdownItem text="Up to £10,000 lump sum if you suffer a personal accident" />
      </ul>
    </Flex>
    <BodyText size="sm" color="secondary">
      This product is regulated by the FCA and sold on a non-advised basis. This
      means our Partners are not authorised to answer questions about it.
    </BodyText>
  </Flex>
);

export { IncomeProtectorHero };
